import { UserManager } from "oidc-client-ts";
import { OidcConfigCMS } from "helpers/configs/oidcConfig";
import LoggerService from "./LoggerService";
import { Location } from "history";

class AuthenticationService {
  private userManager: UserManager;

  constructor() {
    this.userManager = new UserManager(OidcConfigCMS);
  }

  get UserManager(): UserManager {
    return this.userManager;
  }

  async getAccessToken(): Promise<string> {
    var user = await this.userManager.getUser();
    if (!user) {
      return "";
    }
    return user?.access_token;
  }

  async authenticateUser(location: Location<any>) {
    if (!this.userManager || !this.userManager.getUser) {
      return;
    }

    let oidcUser = await this.userManager.getUser();
    let signinTimeStamp;

    function setCookie(cname: string, cvalue: number, expires: string) {
      document.cookie = cname + "=" + cvalue + ";" + expires + ";domain=.abplivestock.com";
    }

    function getCookie(name: string) {
      const value = `; ${document.cookie}`;
      const parts = value.split(`; ${name}=`);
      if (parts.length === 2) return parts.pop().split(";").shift();
    }

    if (!oidcUser || oidcUser.expired) {
      LoggerService.debug("authenticating user ...");

      // let url = location.location.pathname + (location.location.search || "");
      let url = location.pathname + (location.search || "");
      let d = new Date();
      d.setTime(d.getTime() + 30 * 60 * 1000);
      signinTimeStamp = d.getTime();

      let expires = "expires=" + d.toUTCString();
      setCookie("stateStamp", signinTimeStamp, expires);

      document.cookie = "signinTimeStamp=" + signinTimeStamp + "; expires=Thu, 01 Jan 2999 00:00:00 UTC; path=/; domain=.abplivestock.com";
      await this.userManager.signinRedirect({
        state: { url },
        extraQueryParams: {
          stateStamp: signinTimeStamp,
        },
      });
      
    } else {
      const lastLoginName = getCookie("lastLogin");
      if (lastLoginName && lastLoginName !== "S5E-CMS-PKCE") {
        localStorage.clear();
        window.location.reload();
      }
    }
  }

  async signOut() {
    if (!this.userManager || !this.userManager.getUser) {
      return;
    }

    let oidcUser = await this.userManager.getUser();
    if (oidcUser) {
      LoggerService.info("Logout user...");
      localStorage.clear();
      document.cookie = "stateStamp=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=.abplivestock.com";
      await this.userManager.signoutRedirect({
        id_token_hint: oidcUser.id_token,
      });
    }
  }
}

const authenticationServiceInstance = new AuthenticationService();

export default authenticationServiceInstance;
